__turbopack_context__.v({
  "active": "ThemeInfo-module__BYV2yq__active",
  "card": "ThemeInfo-module__BYV2yq__card",
  "check": "ThemeInfo-module__BYV2yq__check",
  "icon": "ThemeInfo-module__BYV2yq__icon",
  "info": "ThemeInfo-module__BYV2yq__info",
  "name": "ThemeInfo-module__BYV2yq__name",
  "preview": "ThemeInfo-module__BYV2yq__preview",
  "publisher": "ThemeInfo-module__BYV2yq__publisher",
});
